import { render, staticRenderFns } from "./doctor.vue?vue&type=template&id=020255be&scoped=true"
import script from "./doctor.vue?vue&type=script&lang=js"
export * from "./doctor.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/home.css?vue&type=style&index=0&id=020255be&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020255be",
  null
  
)

export default component.exports